var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-cancel",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M17.538,14.929,3.432.821a1.574,1.574,0,0,0-2.227,0l-.743.742a1.575,1.575,0,0,0,0,2.227L14.568,17.9a1.574,1.574,0,0,0,2.227,0l.742-.742a1.573,1.573,0,0,0,0-2.227Zm0,0",
    transform: "translate(0 -0.36)",
    fill: "#f44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M14.568.823.461,14.93a1.574,1.574,0,0,0,0,2.227L1.2,17.9a1.574,1.574,0,0,0,2.227,0L17.538,3.794a1.574,1.574,0,0,0,0-2.227L16.8.824a1.575,1.575,0,0,0-2.228,0Zm0,0",
    transform: "translate(0 -0.361)",
    fill: "#f44336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancelIcon.e0d24d85aa30226c221a15353cc6ee0b.svg";
export { ForwardRef as ReactComponent };